var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStationActivityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9999 16L29 20M29 20L27 18.4027M29 20L31 18.4027",
    stroke: "#009D00",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4375 31.4414C22.1546 30.6812 22 29.8587 22 29C22 25.134 25.134 22 29 22C31.6355 22 33.9309 23.4565 35.125 25.6085C34.25 32.0625 27.034 34.1144 22.4375 31.4414Z",
    fill: "#009D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36C32.866 36 36 32.866 36 29C36 27.7695 35.6825 26.6132 35.125 25.6085C34.25 32.0625 27.034 34.1144 22.4375 31.4414C23.4283 34.1036 25.9927 36 29 36Z",
    fill: "#009D00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36C32.866 36 36 32.866 36 29C36 27.7695 35.6825 26.6132 35.125 25.6085C34.25 32.0625 27.034 34.1144 22.4375 31.4414C23.4283 34.1036 25.9927 36 29 36Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12V2C22 1.44772 22.4477 1 23 1H33V11.4C33 11.7314 32.7314 12 32.4 12H22Z",
    fill: "#4D84F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15H23C22.4477 15 22 14.5523 22 14V12H32.4C32.7314 12 33 11.7314 33 11.4V1H35C35.5523 1 36 1.44772 36 2V14C36 14.5523 35.5523 15 35 15Z",
    fill: "#4D84F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15H23C22.4477 15 22 14.5523 22 14V12H32.4C32.7314 12 33 11.7314 33 11.4V1H35C35.5523 1 36 1.44772 36 2V14C36 14.5523 35.5523 15 35 15Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.00007L21 8M21 8L19.4027 10M21 8L19.4027 6",
    stroke: "#DBDBDB",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12V2C1 1.44772 1.44772 1 2 1H12V11.4C12 11.7314 11.7314 12 11.4 12H1Z",
    fill: "#4D84F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15H2C1.44772 15 1 14.5523 1 14V12H11.4C11.7314 12 12 11.7314 12 11.4V1H14C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15Z",
    fill: "#4D84F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15H2C1.44772 15 1 14.5523 1 14V12H11.4C11.7314 12 12 11.7314 12 11.4V1H14C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99993 20L8 16M8 16L6 17.5973M8 16L10 17.5973",
    stroke: "#DBDBDB",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 33V23C1 22.4477 1.44772 22 2 22H12V32.4C12 32.7314 11.7314 33 11.4 33H1Z",
    fill: "#4D84F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14 36H2C1.44772 36 1 35.5523 1 35V33H11.4C11.7314 33 12 32.7314 12 32.4V22H14C14.5523 22 15 22.4477 15 23V35C15 35.5523 14.5523 36 14 36Z",
    fill: "#4D84F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14 36H2C1.44772 36 1 35.5523 1 35V33H11.4C11.7314 33 12 32.7314 12 32.4V22H14C14.5523 22 15 22.4477 15 23V35C15 35.5523 14.5523 36 14 36Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationActivityIcon);
export default __webpack_public_path__ + "static/media/StationActivityIcon.39cf44d6f2298c95bc02ffa5436e30f8.svg";
export { ForwardRef as ReactComponent };